module.exports = __webpack_public_path__ + "static/media/SearchIcon.304321ba.svg";